module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAdCAYAAACqhkzFAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAD8SURBVEiJ7ZUxTsQwEEX/2GmR6LgCxzAFZ6CPlIkL9gxxzgCFNZFyALjBNrv0XIBzUMdDQ1YL2o2wtaLK6+zRPP9pxgQA3ns3TVNHRA5lBBHpAYCYuQMQCkUHVHU/DMNdpaqOiH68kkvTNDsict57Z+YxS2W/qZaKzPwE4PHo6kNEbpd6zCVSHbOYUEQ2ADY5wosnXIWrcBWuwv8Rnt2Hbdveq+r1qZqIvGYJ67q+UtXtuSbv/UOM8eXPwnEcP5n5GcDNqToRvWclBA7rPxua/1QAwRjzViJJKe2+Q1Blre1TSg5ASCmV+GYCANB8YuZOVV2JyVrbxxj3APAF2h9Ulg8CE80AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/mobileversion.png
// module id = t1T4
// module chunks = 46